export enum AerosyncEnvironment {
    Sandbox = "sandbox",
    Production = "production",
};

export const AerosyncUrl = {
    sandbox: "https://sandbox-sync.aero.inc",
    production: "https://sync.aero.inc",
}
